import React, { Component }  from 'react';
import type { Props } from 'astro';
import ReactForm from "@react/jpSupport/ReactForm.tsx";

interface State extends Record<string, any>{
  productOption: Array<object>;
  timestamp: number;
  password: string;
  showTYmessage: boolean;
  tyMessage: string;
}

class SupportTicket extends Component<Props, State> {
  // dafault value
  constructor(props: Props) {
    super(props);
    this.state = {
      productOption: [],
      timestamp: Math.floor(new Date().getTime() / 1000),
      password: this.generatePassword(),
      showTYmessage: false,
      tyMessage: "<p>お問合わせを受け付けました。<br/>サポートへお問い合わせ頂きまして、誠に有難うございます。本サポート内容用のチケット番号が記載されたメールをお送りさせて頂きました。<br/>チケット番号は、次回のお問い合わせ及び確認時に必要となりますので、大切に保管をお願い致します。<br/>なお、サポート内容完了まで進歩状況メールをお送りいたします。随時サポート詳細につきましてはメールをご確認下さいませ。</p><p>有難うございます。<br/>AvePoint サポートチーム</p>",
    };
  }

  async componentDidMount() {
    try {
      const _headers = new Headers();
      _headers.append("Content-Type", "application/x-www-form-urlencoded");
      const requestOptions: RequestInit = {
        method: "GET",
        headers: _headers,
        redirect: "follow"
      };
      // Fetching products data
      const response = await fetch("https://www.avepoint.com/api/v1/support-products", requestOptions);
      const result = await response.json();
      if (result && result.status_code === 200) {
        this.setState({
          productOption: result.data
        });
      } else {
        throw new Error(`Error: ${result.status_message || 'Unknown error'}`);
      }
    } catch (error) {
      throw new Error("Failed to fetch product data.");
    }
  }
  
  generatePassword = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let _password = '';
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      _password += chars.charAt(randomIndex);
    }
    return _password;
  }

  postFormDataToOctober = async (data: Record<string, any>) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const raw = JSON.stringify(data);
      const requestOptions: RequestInit = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow" as RequestRedirect
      };
      // Make the API request
      const response = await fetch("https://www.avepoint.com/api/v1/support-ticket-send-email", requestOptions);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const emailResult = await response.json();
      if (response.ok && emailResult.status_code === 201) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      this.setState({
        showTYmessage: true,
        tyMessage: "<p>申し訳ございません。問題が発生しました。メールの送信中に予期しないエラーが発生しました。</p>"
      });
    }
  };
  
  handleFormSubmit = async (data: Record<string, any>) => {
    try {
      const status = await this.postFormDataToOctober(data);
      if(status) {
        // Build form values based on the submitted data
        const allCRMValues: Record<string, any> = Object.entries(data).reduce<Record<string, any>>((acc, [key, value]) => {
          switch (key) {
            case 'customerid':
            case 'new_suppliedemail':
            case 'new_suppliedphone':
            case 'new_preferred_method__c':
            case 'new_docavesection':
            case 'new_sharepoint_version__c':
            case 'new_support_service_ticket__c':
            case 'description':
              acc[key] = value;
              break;
            case 'new_modules':
              acc['new_casecategory'] = value;
              break;
            case 'new_severity__c':
              const severity = Number(value);
              acc['new_severity__c'] = severity >= 6 ? 'Very High' : severity >= 4 ? 'High' : severity >= 1 ? 'Medium' : 'Low';
              break;
            default:
              break;
          }
          return acc;
        }, {}); // Initial value as an empty object with type Record<string, any>
        const response = await fetch("/api/case/create", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(allCRMValues),
        });
        const result = await response.json();
        if (result.success) {
          this.setState({ showTYmessage: true });
        } else {
          this.setState({
            showTYmessage: true,
            tyMessage: "<p>申し訳ございません。問題が発生しました。予期しないエラーが発生しました。操作を再試行してください。</p>"
          });
        }
      } else {
        this.setState({
          showTYmessage: true,
          tyMessage: "<p>フォームの送信に失敗しました。詳細を確認してもう一度お試しください。</p>",
        });
      }
    } catch (error) {
      this.setState({
        showTYmessage: true,
        tyMessage: "<p>申し訳ございません。問題が発生しました。予期しないエラーが発生しました。操作を再試行してください。</p>"
      });
    }
  };  
  
  render() {
    const { productOption, timestamp, password, showTYmessage, tyMessage } = this.state;
    return (
      <div className='w-full my-20 bg-white'>
        <h1>サポートへのお問い合わせ</h1>
        {!showTYmessage ? <ReactForm productOption={productOption} new_support_service_ticket__c={timestamp} password={password} onSubmit={this.handleFormSubmit} /> : <div className='pt-20' dangerouslySetInnerHTML={{ __html:tyMessage }}></div>}
      </div>
    );
  }
}

export default SupportTicket;